/**
 * uploadErrorMessage — Message affiché après un échec de POST /api/sessions/upload.
 *
 * Les erreurs d'import nées avec le dispatcher de formats (D192) arrivent en
 * code (unknownFormat, tooShort, noPmData) et sont traduites ; les autres
 * restent le message renvoyé par le serveur, comme avant.
 */
export function uploadErrorMessage(data, t) {
  const fallback = data?.error || data?.message || t('sessions.csv.importError');
  return data?.code ? t(`sessions.csv.errors.${data.code}`, { defaultValue: fallback }) : fallback;
}
